"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSlider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_slick_1 = __importDefault(require("react-slick"));
var CarouselPagination_1 = require("../../components/carousel/CarouselPagination");
// for IconStacks7 and TextLayouts5
var QuoteSlider = function (_a) {
    var children = _a.children;
    var sliderRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = (0, react_1.useState)(false), isAnimating = _c[0], setIsAnimating = _c[1];
    var goTo = function (index) {
        if (isAnimating)
            return;
        setActiveIndex(index);
        sliderRef.current.slickGoTo(index);
    };
    var settings = {
        arrows: false,
        dots: false,
        fade: true,
        cssEase: 'ease',
        speed: 1000,
        draggable: false,
        beforeChange: function () { return setIsAnimating(true); },
        afterChange: function () { return setIsAnimating(false); },
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "position-relative" }, { children: [(0, jsx_runtime_1.jsx)(react_slick_1.default, __assign({ ref: sliderRef }, settings, { className: "slick-quotes" }, { children: children })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "position-absolute bottom-0 start-50 translate-middle-x mb-10" }, { children: (0, jsx_runtime_1.jsx)(CarouselPagination_1.CarouselPagination, { length: children.length, activeIndex: activeIndex, goTo: goTo }) }))] })));
};
exports.QuoteSlider = QuoteSlider;
